import * as Popover from '@radix-ui/react-popover'
import EmojiPickerPanel from './EmojiPickerPanel'

/** THE reaction drawer — one declaration for every way in (the hover strip's
 *  + cell, the right-click menu's "more", the thread's rows). Hosts declare
 *  only the open state and what to do with the pick; the floating behaviour,
 *  the dismissal contract and the panel itself live here, so no two entrances
 *  can drift apart.
 *
 *  `trigger` is optional: pass a button and the drawer hangs off it (and Radix
 *  keeps data-state="open" on it, which is what holds the hover strip up while
 *  the drawer is out). Pass nothing and it hangs off an invisible anchor sitting
 *  wherever the component is placed. */
export default function ReactionPicker({ open, onOpenChange, onSelect, trigger, side = 'top', align = 'start' }) {
  return (
    <Popover.Root open={open} onOpenChange={onOpenChange}>
      {trigger ? (
        <Popover.Trigger asChild>{trigger}</Popover.Trigger>
      ) : (
        <Popover.Anchor asChild><span className="emoji-picker-reaction-anchor" /></Popover.Anchor>
      )}
      <Popover.Portal>
        <Popover.Content
          className="emoji-reaction-popover"
          side={side}
          align={align}
          sideOffset={6}
          collisionPadding={12}
          /* The panel focuses its own search field, so Radix must not fight it. */
          onOpenAutoFocus={(e) => e.preventDefault()}
          /* One entrance is a Radix menu item, and a closing menu restores focus
             to ITS trigger — a focusin outside this layer, which by default
             dismisses the drawer in the same frame it appeared. Pointer-outside
             and Escape still close it; only the focus route is refused. */
          onFocusOutside={(e) => e.preventDefault()}
        >
          <EmojiPickerPanel onSelect={onSelect} />
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  )
}
